import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    navigationBox: {
        flexGrow: 1,
        overflowY: "auto",
        overflowX: "hidden",
        scrollbarWidth: "none",
        backgroundColor:
            theme.palette.mode === "light" ? theme.palette.emteria.background.default : theme.palette.emteria.background.paper,
        "&::-webkit-scrollbar": {
            display: "none",
        },
    },
    workspaceTitle: { position: "absolute", bottom: theme.spacing(1), left: theme.spacing(3), fontSize: 10, fontStyle: "italic" },
}));
